import rest from "@/rest-client";
import vuexStore from "@/store/customSaveStore";

export const datasourceOtherCollectMethod = vuexStore({
  namespaced: true,
  path: "/datasource-other-collect-method",
  state: {
    editedDatasource: null,
    // TKP-74: veri kartından girilen kayıt düğüme bağlanır (kaynak yok)
    editedProcessData: null,
  },
  getters: {
    editedDatasource: (state) => state.editedDatasource,
    editedProcessData: (state) => state.editedProcessData,
  },
  mutations: {
    editedDatasource: (state, value) => (state.editedDatasource = value),
    editedProcessData: (state, value) => (state.editedProcessData = value),
  },
  actions: {
    addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.post("/datasource-other-collect-method", payload);
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationOtherCollectMethod = vuexStore({
  namespaced: true,
  path: "/other-collect-method",
});
